//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AggregateMetricsTimePeriod, AggregatedSaleMetric, BuyerInfo, CreateRetailSaleWithPaymentInput, CreateRetailSaleWithPaymentResponse, EntitiesWithSummaryOfSale, EntitiesWithSummaryOfSaleWithCatalogData, EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData, FileResponse, MarketplaceSaleInput, MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2, PosManagedMarketplaceSaleInput, PosUiActionResult, ProblemDetails, Sale, SaleAggregationResponse, SaleAggregationSummary, SaleAvailableSeatings, SaleCancellationReason, SaleDetails, SaleFilterQueryV2, SaleInput, SaleLineItem, SaleQuery, SaleQueryV2, SaleSearchRequestV2, SaleWithCatalogData, Seating, SecureSalesSearchMappedResult, TicketBarcode, TicketExternalId, TicketTransferRequest, TicketUrl, UnwasteSaleInput, UserDocument, ValueTupleOfIEnumerableOfSaleAndUInt64, ValueTupleOfLongAndNullableBoolean, WasteListingTicketsInput } from './types';


export interface ISaleClient {

    getSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }>;

    /**
     * This use the exact same backend as GetSalesForEvents, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param requireEventIds (optional) 
     * @param useReadonlyDB (optional) 
     * @param includeInternalNotes (optional) 
     */
    searchSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }>;

    /**
     * Advanced search V2 with OpenSearch backend to get paginated results
     */
    searchSalesForEventsV2(query: SaleQueryV2): Promise<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData>;

    /**
     * Advanced search V2 with OpenSearch backend to result summary
     */
    searchSalesForEventsV2Summary(query: SaleQueryV2): Promise<SaleWithCatalogData>;

    getRecentSales(minRowVersion: number | undefined): Promise<ValueTupleOfIEnumerableOfSaleAndUInt64>;

    getUnableToProcessSales(): Promise<{ [key: string]: Sale[]; }>;

    getSalesByMarketplaceSaleId(marketplaceSaleId: string | undefined): Promise<Sale[]>;

    getSaleBySaleId(saleId: number | undefined): Promise<SaleDetails>;

    confirmAllocationSale(saleId: number | undefined, seatingToAllocate: Seating | undefined, skipAllocationValidation: boolean | null | undefined): Promise<PosUiActionResult>;

    rejectSale(saleId: number | undefined, keepAllocatedTickets: boolean | null | undefined, cancellationReason: SaleCancellationReason | null | undefined): Promise<PosUiActionResult>;

    deallocateSale(saleId: number | undefined, adminHold: boolean | undefined): Promise<PosUiActionResult>;

    saveETicketAssignments(saleId: number | undefined, eticketImages: UserDocument[]): Promise<PosUiActionResult>;

    saveQRCodeAssignments(saleId: number | undefined, qrCodes: UserDocument[]): Promise<PosUiActionResult>;

    updateBarcodesForSale(saleId: number | undefined, ticketBarcodes: TicketBarcode[]): Promise<PosUiActionResult>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    saveTicketTransferInfoBySaleId(saleId: number, request: TicketTransferRequest): Promise<PosUiActionResult>;

    resetFulfillment(saleId: number | undefined, removeArtifacts: boolean | undefined): Promise<PosUiActionResult>;

    markAsFulfilled(saleId: number | undefined): Promise<PosUiActionResult>;

    getBarcodesAlreadyInUse(viagogoVirtualId: string | undefined, ticketBarcodes: TicketBarcode[]): Promise<TicketBarcode[]>;

    getTicketExternalIdsAlreadyInUse(viagogoVirtualId: string | undefined, externalIds: TicketExternalId[]): Promise<TicketExternalId[]>;

    getTicketUrlsAlreadyInUse(viagogoVirtualId: string | undefined, urls: TicketUrl[]): Promise<TicketUrl[]>;

    expireHold(saleId: number | undefined): Promise<PosUiActionResult>;

    getSeatingsForSaleAllocation(saleId: number | undefined, allPossibleSeatings: boolean | undefined, isAllocateSingleTickets: boolean | undefined): Promise<SaleAvailableSeatings>;

    exportSales(query: SaleQuery): Promise<FileResponse>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleBySaleId(saleId: number, saleInput: SaleInput): Promise<PosUiActionResult>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleIsNoFulfillBySaleId(saleId: number, input: ValueTupleOfLongAndNullableBoolean): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergePosManagedMarketplaceSaleForListingId(listingId: number, input: PosManagedMarketplaceSaleInput): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    createRetailSaleWithPaymentForListingId(listingId: number, input: CreateRetailSaleWithPaymentInput): Promise<CreateRetailSaleWithPaymentResponse>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeDonationSaleForListingId(listingId: number, input: PosManagedMarketplaceSaleInput): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeMarketplaceSaleForListingId(listingId: number, input: MarketplaceSaleInput): Promise<PosUiActionResult>;

    getAllAvailableBuyers(): Promise<BuyerInfo[]>;

    downloadMergedUserDocumentsPdf(saleId: number | undefined): Promise<FileResponse>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    wasteListingTicketsByListingId(listingId: number, input: WasteListingTicketsInput): Promise<PosUiActionResult>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    unwasteSaleBySaleId(saleId: number, input: UnwasteSaleInput): Promise<PosUiActionResult>;

    getSaleLineItemsBySaleId(saleId: number | undefined): Promise<SaleLineItem[]>;

    getAggregatedSaleMetrics(timePeriod: AggregateMetricsTimePeriod | undefined, timezoneOffsetMins: number | undefined): Promise<AggregatedSaleMetric[]>;

    backfillCancelledProceeds(): Promise<PosUiActionResult>;

    spoilTicketsInSale(saleId: number | undefined): Promise<PosUiActionResult>;

    unspoilTicketsInSale(saleId: number | undefined, ticketIds: number[] | undefined): Promise<PosUiActionResult>;
}

export class SaleClient extends PosClientBase implements ISaleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        let url_ = this.baseUrl + "/api/Sale/GetSalesForEvents?";
        if (requireEventIds === null)
            throw new Error("The parameter 'requireEventIds' cannot be null.");
        else if (requireEventIds !== undefined)
            url_ += "requireEventIds=" + encodeURIComponent("" + requireEventIds) + "&";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesForEvents(_response);
        });
    }

    protected processGetSalesForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfSale; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfSale; }>(null as any);
    }

    /**
     * This use the exact same backend as GetSalesForEvents, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param requireEventIds (optional) 
     * @param useReadonlyDB (optional) 
     * @param includeInternalNotes (optional) 
     */
    searchSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        let url_ = this.baseUrl + "/api/Sale/SearchSalesForEvents?";
        if (requireEventIds === null)
            throw new Error("The parameter 'requireEventIds' cannot be null.");
        else if (requireEventIds !== undefined)
            url_ += "requireEventIds=" + encodeURIComponent("" + requireEventIds) + "&";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesForEvents(_response);
        });
    }

    protected processSearchSalesForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfSale; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfSale; }>(null as any);
    }

    /**
     * Advanced search V2 with OpenSearch backend to get paginated results
     */
    searchSalesForEventsV2(query: SaleQueryV2, signal?: AbortSignal | undefined): Promise<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData> {
        let url_ = this.baseUrl + "/api/Sale/SearchSalesForEventsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesForEventsV2(_response);
        });
    }

    protected processSearchSalesForEventsV2(response: Response): Promise<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData>(null as any);
    }

    /**
     * Advanced search V2 with OpenSearch backend to result summary
     */
    searchSalesForEventsV2Summary(query: SaleQueryV2, signal?: AbortSignal | undefined): Promise<SaleWithCatalogData> {
        let url_ = this.baseUrl + "/api/Sale/SearchSalesForEventsV2Summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesForEventsV2Summary(_response);
        });
    }

    protected processSearchSalesForEventsV2Summary(response: Response): Promise<SaleWithCatalogData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleWithCatalogData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleWithCatalogData>(null as any);
    }

    getRecentSales(minRowVersion: number | undefined, signal?: AbortSignal | undefined): Promise<ValueTupleOfIEnumerableOfSaleAndUInt64> {
        let url_ = this.baseUrl + "/api/Sale/GetRecentSales?";
        if (minRowVersion === null)
            throw new Error("The parameter 'minRowVersion' cannot be null.");
        else if (minRowVersion !== undefined)
            url_ += "minRowVersion=" + encodeURIComponent("" + minRowVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentSales(_response);
        });
    }

    protected processGetRecentSales(response: Response): Promise<ValueTupleOfIEnumerableOfSaleAndUInt64> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfIEnumerableOfSaleAndUInt64;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfIEnumerableOfSaleAndUInt64>(null as any);
    }

    getUnableToProcessSales(signal?: AbortSignal | undefined): Promise<{ [key: string]: Sale[]; }> {
        let url_ = this.baseUrl + "/api/Sale/GetUnableToProcessSales";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnableToProcessSales(_response);
        });
    }

    protected processGetUnableToProcessSales(response: Response): Promise<{ [key: string]: Sale[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Sale[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Sale[]; }>(null as any);
    }

    getSalesByMarketplaceSaleId(marketplaceSaleId: string | undefined, signal?: AbortSignal | undefined): Promise<Sale[]> {
        let url_ = this.baseUrl + "/api/Sale/GetSalesByMarketplaceSaleId?";
        if (marketplaceSaleId === null)
            throw new Error("The parameter 'marketplaceSaleId' cannot be null.");
        else if (marketplaceSaleId !== undefined)
            url_ += "marketplaceSaleId=" + encodeURIComponent("" + marketplaceSaleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesByMarketplaceSaleId(_response);
        });
    }

    protected processGetSalesByMarketplaceSaleId(response: Response): Promise<Sale[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Sale[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sale[]>(null as any);
    }

    getSaleBySaleId(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<SaleDetails> {
        let url_ = this.baseUrl + "/api/Sale/GetSaleBySaleId?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleBySaleId(_response);
        });
    }

    protected processGetSaleBySaleId(response: Response): Promise<SaleDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleDetails>(null as any);
    }

    confirmAllocationSale(saleId: number | undefined, seatingToAllocate: Seating | undefined, skipAllocationValidation: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/ConfirmAllocationSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (skipAllocationValidation !== undefined && skipAllocationValidation !== null)
            url_ += "skipAllocationValidation=" + encodeURIComponent("" + skipAllocationValidation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seatingToAllocate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmAllocationSale(_response);
        });
    }

    protected processConfirmAllocationSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    rejectSale(saleId: number | undefined, keepAllocatedTickets: boolean | null | undefined, cancellationReason: SaleCancellationReason | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/RejectSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (keepAllocatedTickets !== undefined && keepAllocatedTickets !== null)
            url_ += "keepAllocatedTickets=" + encodeURIComponent("" + keepAllocatedTickets) + "&";
        if (cancellationReason !== undefined && cancellationReason !== null)
            url_ += "cancellationReason=" + encodeURIComponent("" + cancellationReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectSale(_response);
        });
    }

    protected processRejectSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    deallocateSale(saleId: number | undefined, adminHold: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/DeallocateSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (adminHold === null)
            throw new Error("The parameter 'adminHold' cannot be null.");
        else if (adminHold !== undefined)
            url_ += "adminHold=" + encodeURIComponent("" + adminHold) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeallocateSale(_response);
        });
    }

    protected processDeallocateSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    saveETicketAssignments(saleId: number | undefined, eticketImages: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveETicketAssignments?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eticketImages);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveETicketAssignments(_response);
        });
    }

    protected processSaveETicketAssignments(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    saveQRCodeAssignments(saleId: number | undefined, qrCodes: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveQRCodeAssignments?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qrCodes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveQRCodeAssignments(_response);
        });
    }

    protected processSaveQRCodeAssignments(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateBarcodesForSale(saleId: number | undefined, ticketBarcodes: TicketBarcode[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateBarcodesForSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBarcodesForSale(_response);
        });
    }

    protected processUpdateBarcodesForSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    saveTicketTransferInfoBySaleId(saleId: number, request: TicketTransferRequest, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveTicketTransferInfoBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTicketTransferInfoBySaleId(_response);
        });
    }

    protected processSaveTicketTransferInfoBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    resetFulfillment(saleId: number | undefined, removeArtifacts: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/ResetFulfillment?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (removeArtifacts === null)
            throw new Error("The parameter 'removeArtifacts' cannot be null.");
        else if (removeArtifacts !== undefined)
            url_ += "removeArtifacts=" + encodeURIComponent("" + removeArtifacts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetFulfillment(_response);
        });
    }

    protected processResetFulfillment(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    markAsFulfilled(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MarkAsFulfilled?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAsFulfilled(_response);
        });
    }

    protected processMarkAsFulfilled(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getBarcodesAlreadyInUse(viagogoVirtualId: string | undefined, ticketBarcodes: TicketBarcode[], signal?: AbortSignal | undefined): Promise<TicketBarcode[]> {
        let url_ = this.baseUrl + "/api/Sale/GetBarcodesAlreadyInUse?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBarcodesAlreadyInUse(_response);
        });
    }

    protected processGetBarcodesAlreadyInUse(response: Response): Promise<TicketBarcode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TicketBarcode[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketBarcode[]>(null as any);
    }

    getTicketExternalIdsAlreadyInUse(viagogoVirtualId: string | undefined, externalIds: TicketExternalId[], signal?: AbortSignal | undefined): Promise<TicketExternalId[]> {
        let url_ = this.baseUrl + "/api/Sale/GetTicketExternalIdsAlreadyInUse?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketExternalIdsAlreadyInUse(_response);
        });
    }

    protected processGetTicketExternalIdsAlreadyInUse(response: Response): Promise<TicketExternalId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TicketExternalId[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketExternalId[]>(null as any);
    }

    getTicketUrlsAlreadyInUse(viagogoVirtualId: string | undefined, urls: TicketUrl[], signal?: AbortSignal | undefined): Promise<TicketUrl[]> {
        let url_ = this.baseUrl + "/api/Sale/GetTicketUrlsAlreadyInUse?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urls);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketUrlsAlreadyInUse(_response);
        });
    }

    protected processGetTicketUrlsAlreadyInUse(response: Response): Promise<TicketUrl[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TicketUrl[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketUrl[]>(null as any);
    }

    expireHold(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/ExpireHold?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExpireHold(_response);
        });
    }

    protected processExpireHold(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getSeatingsForSaleAllocation(saleId: number | undefined, allPossibleSeatings: boolean | undefined, isAllocateSingleTickets: boolean | undefined, signal?: AbortSignal | undefined): Promise<SaleAvailableSeatings> {
        let url_ = this.baseUrl + "/api/Sale/GetSeatingsForSaleAllocation?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (allPossibleSeatings === null)
            throw new Error("The parameter 'allPossibleSeatings' cannot be null.");
        else if (allPossibleSeatings !== undefined)
            url_ += "allPossibleSeatings=" + encodeURIComponent("" + allPossibleSeatings) + "&";
        if (isAllocateSingleTickets === null)
            throw new Error("The parameter 'isAllocateSingleTickets' cannot be null.");
        else if (isAllocateSingleTickets !== undefined)
            url_ += "isAllocateSingleTickets=" + encodeURIComponent("" + isAllocateSingleTickets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeatingsForSaleAllocation(_response);
        });
    }

    protected processGetSeatingsForSaleAllocation(response: Response): Promise<SaleAvailableSeatings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleAvailableSeatings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleAvailableSeatings>(null as any);
    }

    exportSales(query: SaleQuery, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Sale/ExportSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportSales(_response);
        });
    }

    protected processExportSales(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleBySaleId(saleId: number, saleInput: SaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateSaleBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSaleBySaleId(_response);
        });
    }

    protected processUpdateSaleBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleIsNoFulfillBySaleId(saleId: number, input: ValueTupleOfLongAndNullableBoolean, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateSaleIsNoFulfillBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSaleIsNoFulfillBySaleId(_response);
        });
    }

    protected processUpdateSaleIsNoFulfillBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergePosManagedMarketplaceSaleForListingId(listingId: number, input: PosManagedMarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergePosManagedMarketplaceSaleForListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePosManagedMarketplaceSaleForListingId(_response);
        });
    }

    protected processMergePosManagedMarketplaceSaleForListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    createRetailSaleWithPaymentForListingId(listingId: number, input: CreateRetailSaleWithPaymentInput, signal?: AbortSignal | undefined): Promise<CreateRetailSaleWithPaymentResponse> {
        let url_ = this.baseUrl + "/api/Sale/CreateRetailSaleWithPaymentForListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRetailSaleWithPaymentForListingId(_response);
        });
    }

    protected processCreateRetailSaleWithPaymentForListingId(response: Response): Promise<CreateRetailSaleWithPaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateRetailSaleWithPaymentResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRetailSaleWithPaymentResponse>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeDonationSaleForListingId(listingId: number, input: PosManagedMarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergeDonationSaleForListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeDonationSaleForListingId(_response);
        });
    }

    protected processMergeDonationSaleForListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeMarketplaceSaleForListingId(listingId: number, input: MarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergeMarketplaceSaleForListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeMarketplaceSaleForListingId(_response);
        });
    }

    protected processMergeMarketplaceSaleForListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getAllAvailableBuyers(signal?: AbortSignal | undefined): Promise<BuyerInfo[]> {
        let url_ = this.baseUrl + "/api/Sale/GetAllAvailableBuyers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAvailableBuyers(_response);
        });
    }

    protected processGetAllAvailableBuyers(response: Response): Promise<BuyerInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuyerInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerInfo[]>(null as any);
    }

    downloadMergedUserDocumentsPdf(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Sale/DownloadMergedUserDocumentsPdf?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMergedUserDocumentsPdf(_response);
        });
    }

    protected processDownloadMergedUserDocumentsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    wasteListingTicketsByListingId(listingId: number, input: WasteListingTicketsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/WasteListingTicketsByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWasteListingTicketsByListingId(_response);
        });
    }

    protected processWasteListingTicketsByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    unwasteSaleBySaleId(saleId: number, input: UnwasteSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UnwasteSaleBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnwasteSaleBySaleId(_response);
        });
    }

    protected processUnwasteSaleBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getSaleLineItemsBySaleId(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<SaleLineItem[]> {
        let url_ = this.baseUrl + "/api/Sale/GetSaleLineItemsBySaleId?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleLineItemsBySaleId(_response);
        });
    }

    protected processGetSaleLineItemsBySaleId(response: Response): Promise<SaleLineItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleLineItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleLineItem[]>(null as any);
    }

    getAggregatedSaleMetrics(timePeriod: AggregateMetricsTimePeriod | undefined, timezoneOffsetMins: number | undefined, signal?: AbortSignal | undefined): Promise<AggregatedSaleMetric[]> {
        let url_ = this.baseUrl + "/api/Sale/GetAggregatedSaleMetrics?";
        if (timePeriod === null)
            throw new Error("The parameter 'timePeriod' cannot be null.");
        else if (timePeriod !== undefined)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        if (timezoneOffsetMins === null)
            throw new Error("The parameter 'timezoneOffsetMins' cannot be null.");
        else if (timezoneOffsetMins !== undefined)
            url_ += "timezoneOffsetMins=" + encodeURIComponent("" + timezoneOffsetMins) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAggregatedSaleMetrics(_response);
        });
    }

    protected processGetAggregatedSaleMetrics(response: Response): Promise<AggregatedSaleMetric[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AggregatedSaleMetric[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AggregatedSaleMetric[]>(null as any);
    }

    backfillCancelledProceeds(signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/BackfillCancelledProceeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBackfillCancelledProceeds(_response);
        });
    }

    protected processBackfillCancelledProceeds(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    spoilTicketsInSale(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SpoilTicketsInSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSpoilTicketsInSale(_response);
        });
    }

    protected processSpoilTicketsInSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    unspoilTicketsInSale(saleId: number | undefined, ticketIds: number[] | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UnspoilTicketsInSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnspoilTicketsInSale(_response);
        });
    }

    protected processUnspoilTicketsInSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }
}
export interface ISalesAggregationOpenSearchClient {

    /**
     * Gets aggregated sale summary with currency conversion
     * @param request Aggregation request containing filters and options
     * @return Aggregated sale summary in target currency
     */
    summary(request: MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2): Promise<SaleAggregationResponse>;

    /**
     * Gets aggregated sale summary by original currency (for debugging/analysis)
     * @param request Aggregation request containing filters and options
     * @return Raw aggregation results by currency
     */
    byCurrency(request: MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2): Promise<{ [key: string]: SaleAggregationSummary; }>;

    /**
     * Gets sales with aggregated summary for UI display
    Combines individual sale data with computed aggregated totals
     * @param request Search request with filters and aggregation options
     * @return Sales with aggregated summary
     */
    uIList(request: MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2): Promise<EntitiesWithSummaryOfSaleWithCatalogData>;
}

export class SalesAggregationOpenSearchClient extends PosClientBase implements ISalesAggregationOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets aggregated sale summary with currency conversion
     * @param request Aggregation request containing filters and options
     * @return Aggregated sale summary in target currency
     */
    summary(request: MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2, signal?: AbortSignal | undefined): Promise<SaleAggregationResponse> {
        let url_ = this.baseUrl + "/api/OpenSearch/SalesAggregation/Summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<SaleAggregationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleAggregationResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleAggregationResponse>(null as any);
    }

    /**
     * Gets aggregated sale summary by original currency (for debugging/analysis)
     * @param request Aggregation request containing filters and options
     * @return Raw aggregation results by currency
     */
    byCurrency(request: MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2, signal?: AbortSignal | undefined): Promise<{ [key: string]: SaleAggregationSummary; }> {
        let url_ = this.baseUrl + "/api/OpenSearch/SalesAggregation/ByCurrency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processByCurrency(_response);
        });
    }

    protected processByCurrency(response: Response): Promise<{ [key: string]: SaleAggregationSummary; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: SaleAggregationSummary; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: SaleAggregationSummary; }>(null as any);
    }

    /**
     * Gets sales with aggregated summary for UI display
    Combines individual sale data with computed aggregated totals
     * @param request Search request with filters and aggregation options
     * @return Sales with aggregated summary
     */
    uIList(request: MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfSaleWithCatalogData> {
        let url_ = this.baseUrl + "/api/OpenSearch/SalesAggregation/UIList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUIList(_response);
        });
    }

    protected processUIList(response: Response): Promise<EntitiesWithSummaryOfSaleWithCatalogData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfSaleWithCatalogData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfSaleWithCatalogData>(null as any);
    }
}
export interface ISalesOpenSearchClient {

    /**
     * Enhanced sales search with ComprehensiveSaleDocument mapped to UI DTOs
    Uses ComprehensiveSaleDocument for comprehensive filtering then maps to Sale DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with SaleFilterQueryV2 criteria and options
     * @return Search results mapped to Sale DTOs with comprehensive search capabilities
     */
    searchSalesV3(request: SaleSearchRequestV2): Promise<SecureSalesSearchMappedResult>;
}

export class SalesOpenSearchClient extends PosClientBase implements ISalesOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Enhanced sales search with ComprehensiveSaleDocument mapped to UI DTOs
    Uses ComprehensiveSaleDocument for comprehensive filtering then maps to Sale DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with SaleFilterQueryV2 criteria and options
     * @return Search results mapped to Sale DTOs with comprehensive search capabilities
     */
    searchSalesV3(request: SaleSearchRequestV2, signal?: AbortSignal | undefined): Promise<SecureSalesSearchMappedResult> {
        let url_ = this.baseUrl + "/api/OpenSearch/SearchSalesV3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesV3(_response);
        });
    }

    protected processSearchSalesV3(response: Response): Promise<SecureSalesSearchMappedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecureSalesSearchMappedResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureSalesSearchMappedResult>(null as any);
    }
}
